import gql from 'graphql-tag';

export default gql`
  query listMenu {
    listMenu {
      __typename
      id
      title
      price
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/graphql/queries/listMenu.ts